import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { apiRequest } from "../Services/apiClient";

// Admin overview: visitors counted by the API (one per browser and per day, robots and Admin excluded).
// The route is Admin-only on the server (GET /api/admin/stats/visitors); nothing here grants access.
export default function AdminVisitors() {
  const { t, i18n } = useTranslation();
  const [data, setData] = useState(null), [error, setError] = useState(false);
  useEffect(() => {
    const controller = new AbortController();
    apiRequest("admin/stats/visitors", { signal: controller.signal })
      .then(result => { if (!controller.signal.aborted) setData(result); })
      .catch(() => { if (!controller.signal.aborted) setError(true); });
    return () => controller.abort();
  }, []);
  const number = value => (Number.isFinite(Number(value)) && value !== null && value !== undefined ? Number(value).toLocaleString(i18n.language) : "—");
  const day = value => {
    const date = value ? new Date(value + "T12:00:00Z") : null;
    return date && !Number.isNaN(date.getTime()) ? date.toLocaleDateString(i18n.language, { weekday: "short", day: "numeric", month: "short", timeZone: "UTC" }) : "—";
  };
  return <section className="lina-admin-visitors" aria-labelledby="admin-visitors-title">
    <h3 id="admin-visitors-title">{t("administration.visitorsTitle")}</h3>
    {error && <p role="alert">{t("administration.visitorsError")}</p>}
    {!data && !error && <p role="status">{t("administration.loading")}</p>}
    {data && <>
      <div className="lina-admin-stats">
        <article><p>{t("administration.visitorsToday")}</p><strong>{number(data.today)}</strong></article>
        <article><p>{t("administration.visitorsTotal")}</p><strong>{number(data.total)}</strong></article>
      </div>
      <div className="lina-admin-table" tabIndex={0} role="region" aria-label={t("administration.visitorsLast7Days")}>
        <table>
          <caption>{t("administration.visitorsLast7Days")}</caption>
          <thead><tr><th scope="col">{t("administration.date")}</th><th scope="col">{t("administration.visitorsCount")}</th></tr></thead>
          <tbody>{(Array.isArray(data.last7Days) ? data.last7Days : []).map(row => <tr key={row.day}><td>{day(row.day)}</td><td>{number(row.count)}</td></tr>)}</tbody>
        </table>
      </div>
    </>}
  </section>;
}
